import { createFileRoute, redirect } from '@tanstack/react-router';
import { meQuery } from '@/lib/me';

// /finance itself shows nothing of its own. The queue is the way in for
// anyone who can see money (slice 1 sent everyone to /finance/accounts;
// slice 2 moves that default to the queue, spec §9 SPA). A finance.submit
// -only actor (a cleaner or handyman with no finance.read — spec §8.3) has
// no use for the queue and every OTHER tab under /finance 403s them
// (finance.tsx's own gate), so they go straight to the phone form instead.
//
// _app's own beforeLoad has already ensureQueryData'd meQuery by the time
// any child route's beforeLoad runs (TanStack Router awaits parent
// beforeLoad before children), so a synchronous cache read here never races
// the fetch — no loading state to render, no flash of the wrong redirect.
export const Route = createFileRoute('/_app/finance/')({
  beforeLoad: ({ context }) => {
    const me = context.queryClient.getQueryData(meQuery.queryKey);
    const canRead = me?.permissions?.includes('finance.read') ?? false;
    throw redirect({ to: canRead ? '/finance/queue' : '/finance/submit' });
  },
});
